// Video modal (hero institucional "Ver video completo" + expertos-videos).
// Opens on [data-video-open="<modal-id>"], closes on [data-video-close],
// overlay click, or Escape. Pauses + rewinds the <video> on close so audio
// stops. Self-contained (.video-modal / .is-open) — no jQuery, no clash with
// the generic src/modals.js handler.
// Event delegation on document: openers inside Owl carousel CLONES (loop mode
// duplicates the cards after DOMContentLoaded) work without re-binding.

document.addEventListener('DOMContentLoaded', function () {
  let activeModal = null

  function getVideo(modal) {
    return modal ? modal.querySelector('.video-modal__video') : null
  }

  function openModal(modal) {
    if (!modal) return
    modal.classList.add('is-open')
    modal.setAttribute('aria-hidden', 'false')
    document.body.classList.add('video-modal-open')
    activeModal = modal
    const video = getVideo(modal)
    if (video) {
      const playPromise = video.play()
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {})
      }
    }
  }

  function closeModal(modal) {
    if (!modal) return
    modal.classList.remove('is-open')
    modal.setAttribute('aria-hidden', 'true')
    document.body.classList.remove('video-modal-open')
    const video = getVideo(modal)
    if (video) {
      video.pause()
      try { video.currentTime = 0 } catch (e) {}
    }
    if (activeModal === modal) activeModal = null
  }

  document.addEventListener('click', function (e) {
    const opener = e.target.closest('[data-video-open]')
    if (opener) {
      e.preventDefault()
      openModal(document.getElementById(opener.getAttribute('data-video-open')))
      return
    }
    const closer = e.target.closest('[data-video-close]')
    if (closer) closeModal(closer.closest('.video-modal'))
  })

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && activeModal) closeModal(activeModal)
  })
})
